<template>
  <div class='layout quiz-select'>
    <div class="column">
      <h1 v-if='config.title' class='title'>{{ config.title }}</h1>
      <h1 key='question'>{{ config.question }}</h1>
    </div>
    <div :class="['column multi-select-column', columnStyle]">
      <transition-group appear name='options' v-on:before-appear="beforeEnter" tag='ul' class='question-set quiz-questions' v-bind:css="false">
        <li v-bind:class='{selected: currentSelection == answer.value, "is-correct": corrects[answer.value], "is-incorrect": incorrects[answer.value]}' v-on:click.once.stop='select(answer)' :key='answer.key' v-for='answer in config.answers' :data-c='answer.score > 0' :data-a='answer.value' :style='buttonStyle'>
          <span class='label'>{{ answer.label }}</span>
          <span :class='{icon: true, "hide-icon": hideIcons}'>
            <ion-icon class='correct' name='checkmark-circle-outline'></ion-icon>
            <ion-icon class='incorrect' name='close-circle-outline'></ion-icon>
          </span>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import Vue from 'vue'

export default {
  name: 'QuizSelect',
  props: ['config'],
  data: function () {
    return {
      currentAnswer: null,
      currentSelection: null,
      iconStyles: {},
      corrects: {},
      incorrects: {},
      hideIcons: false,
      complete: false
    }
  },
  computed: {
    columnStyle () {
      return 'multi-select-columns-' + this.columnCount
    },
    buttonStyle () {
      return {
        borderRadius: this.theme.borderRadius + 'px'
      }
    }
  },
  methods: {
    addBackgroundImage () {
      return Object.assign({}, {backgroundImage: 'url(' + this.config.background + ')'})
    },
    select (answer) {
      if (this.complete === true) {
        return
      }
      this.complete = true
      this.currentAnswer = answer
      this.currentSelection = answer.value
      let score = null
      if (answer.score !== null && !isNaN(answer.score)) {
        score = answer.score
      }
      this.$store.dispatch('save',
        {
          key: this.config.key,
          answer: {
            value: this.currentSelection,
            score: score
          }
        }).then((resp) => {
        this.$emit('answer')
        this.markQuizAnswers()
      })
    },
    markQuizAnswers () {
      this.config.answers.forEach((answer) => {
        if (answer.score === 0) {
          this.incorrects[answer.value] = true
        } else {
          this.corrects[answer.value] = true
        }
      })
      const children = this.$el.querySelectorAll('.question-set li')
      let styleChanges
      children.forEach((el, i) => {
        if (el.dataset.c) {
          styleChanges = this.theme.correct
        } else if (el.dataset.a === this.currentSelection) {
          styleChanges = this.theme.incorrect
        } else {
          styleChanges = false
        }
        let options = {duration: 100}
        if (i === children.length - 1) {
          options.complete = setTimeout(this.leave, 2000)
        }
        if (styleChanges) {
          Velocity(
            el,
            styleChanges,
            options
          )
        }
      })
      this.hideIcons = false
    },
    leave () {
      let answer = this.currentAnswer
      this.$gtag.event('answer', {event_category: 'survey', event_label: this.config.key, value: this.currentAnswer})
      if (typeof answer.next !== 'undefined' && answer.next) {
        this.$store.commit('setIndex', this.getNext(answer.next))
      } else if (typeof this.config.next !== 'undefined' && this.config.next) {
        this.$store.commit('setIndex', this.getNext(this.config.next))
      } else {
        this.$store.commit('advance')
      }
    },
    beforeEnter: function (el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: '100%', translateZ: 0 },
        { duration: 0 }
      )
      var delay = 500 + el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          { opacity: 1, translateY: '0%', translateZ: 0 },
          { complete: done, duration: 550 }
        )
      }, delay)
    },
    mergeProperties (ob, newOb) {
      for (let prop in newOb) {
        Vue.set(ob, prop, newOb[prop])
      }
    }
  },
  inject: ['convince', 'theme'],
  mounted () {
    this.currentSelection = null
    window.scroll(0, 0)
  },
  created () {
    this.hideIcons = true
    if (typeof this.config.columns !== 'undefined') {
      this.columnCount = this.config.columns
    } else {
      this.columnCount = 1
    }
  }
}
</script>

<style lang='scss'>
@import '../scss/base';
@import '../scss/components/survey';
</style>
